// extracted by mini-css-extract-plugin
export default {"header":"Header_header__x0Ucu","divider":"Header_divider__aSWfQ","flexColumn":"Header_flexColumn__KybF9","flexBox":"Header_flexBox__c9iQC"};